import { __ } from "./i18n.js";
const MEDIA_DELETE_SHORTCUT_NOTE = __("Note: If you want to delete a shortcut file, the source file will NOT be deleted.\nIf you want to delete a non-shortcut file, all associated shortcuts are deleted, too.");
function getMediaDeleteConfirmMessage(warnDelete) {
    return (warnDelete || "") + MEDIA_DELETE_SHORTCUT_NOTE;
}
export { getMediaDeleteConfirmMessage, MEDIA_DELETE_SHORTCUT_NOTE };
